; (function (jQuery) {

	"use strict";

	function SubMenu() {
		var global = {
		};

		var fn = {
			init: function () {
				fn.addSubmenuColumnClass();
				fn.addSubmenuPositionClass();
			},

			/**
			 * Add CSS class to handle submenu two-column layout when more than 5 items
			 */
			addSubmenuColumnClass: function () {
				const submenus = jQuery('.primary-menu__items-secondary');

				// Check if any submenus exist
				if (submenus.length) {
					submenus.each(function () {
						if (jQuery(this).children().length > 5) {
							jQuery(this).addClass('primary-menu__items-secondary--two-col');
						}
					});
				}
			},

			/**
			 * Setup submenu position handlers
			 */
			addSubmenuPositionClass: function () {
				const submenuParents = jQuery('.primary-menu__link--first-level.menu-item-has-children');

				// Parent menu item hover
				submenuParents.on('mouseenter', function () {
					fn.checkSubmenuPosition(jQuery(this));
				});

				// Submenu toggle button click
				submenuParents.find('.primary-menu__submenu-toggle').on('click', function () {
					const parentItem = jQuery(this).closest('.primary-menu__link--first-level.menu-item-has-children');

					setTimeout(function () {
						fn.checkSubmenuPosition(parentItem);
					}, 50); // delay for submenu to show
				});
			},

			/**
			 * Add CSS class to handle submenu right-hand viewport overflow,
			 * to ensure submenu is always visible within the viewport
			 */
			checkSubmenuPosition: function (parentItem) {
				const submenu = parentItem.children('.primary-menu__items-secondary');

				if (submenu.length) {
					submenu.removeClass('primary-menu__items-secondary--right'); // reset class
					const submenuOffset = submenu.offset();
					const submenuWidth = submenu.outerWidth();
					const viewportWidth = jQuery(window).width();

					if (submenuOffset.left + submenuWidth > viewportWidth) {
						submenu.addClass('primary-menu__items-secondary--right');
					}
				}
			}
		}

		jQuery(fn.init);
	}

	new SubMenu();
})(jQuery);